import { render, staticRenderFns } from "./GeoLangName.vue?vue&type=template&id=26a3c58b&"
import script from "./GeoLangName.vue?vue&type=script&lang=js&"
export * from "./GeoLangName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports